import { getTimezone } from "countries-and-timezones";

export const getSystemTimezone = () =>
  getTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
